module.exports = __webpack_public_path__ + "img/shared4.3674b08e.png";